import React, { useState, useEffect } from 'react';

// 自定义 Hook 用于监听 localStorage 中 thumbnailLocation 的变化
const useThumbnailLocationListener = () => {
    const [thumbnailLocation, setThumbnailLocation] = useState(() => {
        return localStorage.getItem('thumbnailLocation');
    });

    useEffect(() => {
        const handleStorageChange = (event) => {
            if (event.key === 'thumbnailLocation') {
                setThumbnailLocation(event.newValue);
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    return thumbnailLocation;
};

export default useThumbnailLocationListener;
